import React from 'react';
import { Link } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import styles from '../../CSS/Directory.module.css'; // Import the CSS module

export const route = "/officer";
export const role = "Officer";

const OfficerDirectory = () => {
  const pages = [
    { name: 'Officer List', path: '/officer/list' },
    { name: 'Email List', path: '/officer/email-list' },
    { name: 'Check-In', path: '/officer/check-in' },
  ];

  return (
    <div className={`container mt-5`}>
      <h1 className="text-center mb-5">Officer Directory</h1>
      <div className="row justify-content-center">
        {pages.map((page, index) => (
          <div key={index} className="col-md-4 mb-4">
            <div className={`card shadow-sm ${styles.card}`}>
              <div className="card-body">
                <h5 className="card-title">{page.name}</h5>
                <Link to={page.path} className={`btn btn-primary w-100 ${styles.button}`}>
                  Go to {page.name}
                </Link>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default OfficerDirectory;